import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import RoleProtectedRoute from "../../router/RoleProtectedRoute";
import DocumentacionLayout from "./DocumentacionLayout";
import { MENU, DOCUMENTACION_BASE, documentacionDefaultRoute } from "./config";

// Árbol de rutas de /documentacion a partir del MENU, para que submenú y rutas
// nunca se separen. Misma forma que Mantenimiento: una app, submenú plano,
// envuelta en RoleProtectedRoute (los derechos por app los aplica el guard de
// config/access/routes.ts: `/documentacion` → app `documentacion`).
const children: RouteObject[] = [
  { index: true, element: <Navigate to={documentacionDefaultRoute} replace /> },
  // El cast evita el choque entre copias de @types/react (el `ReactNode` del
  // MENU vs. el que espera react-router) en checkouts con node_modules compartidos.
  ...MENU.map((item) => ({ path: item.id, element: item.element as RouteObject["element"] })),
];

export const documentacionRoute: RouteObject = {
  path: DOCUMENTACION_BASE,
  element: <RoleProtectedRoute restrictedRoles={["web_services"]} />,
  children: [
    {
      path: "",
      element: <DocumentacionLayout />,
      children,
    },
  ],
};
